import { atom } from "recoil";
import { Vehicle } from "../types";

export const vehicleState = atom<Vehicle>({
  key: "vehicleState",
  default: {year: '', make: '', model: ''},
});